import { InputAdornment } from "@material-ui/core";
import swal from "@sweetalert/with-react";
import { Form } from "@unform/web";
import React, { useEffect, useRef, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { IoMdCheckmark } from "react-icons/io";
import { MdInsertPhoto } from "react-icons/md";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import DivDiagonal from "../../../components/DivDiagonal";
import CustomButton from "../../../components/Form/Button";
import Input from "../../../components/Form/Input";
import InputMask from "../../../components/Form/InputMask";
import InputSelect from "../../../components/Form/InputSelect";
import messageTypes from "../../../constants/MessagesTypes";
import { edit, getProduct, save } from "../../../services/Product";
import { compressedImage } from "../../../utils/compressedImage";
import { currencyFormat } from "../../../utils/masks";
import {
  ProductNewWrapper,
  ProductCard,
  CardTitle,
  StyledFormWrapper,
  ContentArea,
  PhotoSection,
  PhotoPreview,
  PhotoInfo,
  ButtonContainer,
  VisuallyHiddenInput
} from "./styles";

export default function NewProduct({match}) {
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState(undefined);
  const formRef = useRef(null);
  const history = useHistory();
  const [photo, setPhoto] = useState(null);

  const type = [
    {key: 'PRODUCT', value: 'Produto'},
    {key: 'SERVICE', value: 'Serviço'},
  ];


  async function handleSubmit(data) {
    try {

      if (loading) {
        return;
      }

      setLoading(true);
      formRef.current.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required(messageTypes.REQUIRED_FIELD),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      const formData = new FormData();
      formData.append('name', data.name);
      formData.append('barcode', data.barcode);
      formData.append('type', data.type);
      formData.append('brand', data.brand);
      formData.append('costPrice', data.costPrice);
      formData.append('salePrice', data.salePrice);

      if (photo && photo !== '') {
        formData.append('photo', photo);
      }

      const response = (product) ? await edit(product.id, formData) : await save(formData);

      if (response && response.status === 200) {
        toast.success(messageTypes.SUCCESS);
        history.push('/product');
      } else {
          toast.error(messageTypes.ERROR_SAVE);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      if (err instanceof Yup.ValidationError) {
        const validationErrors = {};
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
        toast.warning(messageTypes.REQUIRED_FIELDS);
        return;
      }

      toast.error(messageTypes.ERROR);
    }
  }

  useEffect(() => {

    const id = match.params.id;
    if (id) {
      setLoading(true);
      getProduct(id).then((data) => {
        setProduct(data);
      }).finally(() => setLoading(false));
    } else {
      setProduct(null);
    }

  }, [match.params.id]);

  
  function showImage(urlImage) {
    swal(
      {
        showCloseButton: true,
        className: 'img-perfil-modal',
        confirmButtonText: 'Fechar',
        content: <div>
          <div className={"img-perfil"}>
            <img src={urlImage} width={'80%'} height={"80%"} alt={'Imagem do produto'}/>
          </div>
        </div>,
      }
    );
  }

  return (
    <ProductNewWrapper>
      <DivDiagonal/>
      <ContentArea>
        {product !== undefined && (
          <>
            <ProductCard>
              <StyledFormWrapper>
                <Form ref={formRef} onSubmit={handleSubmit}>
                  <CardTitle>
                    {product ? (
                      <>
                        <i className="fas fa-edit"/> Editar produto
                      </>
                    ) : (
                      <>
                        <i className="fas fa-plus"/> Novo produto
                      </>
                    )}
                  </CardTitle>
                  
                  <div className="row mb-4">
                    <div className="col-12 col-md-6 mt-4">
                      <Input
                        type="text"
                        name="name"
                        defaultValue={product?.name ?? null}
                        label={"Informe o nome do produto *"}
                      />
                    </div>
                    <div className="col-12 col-md-6 mt-4">
                      <Input
                        type="text"
                        name="barcode"
                        defaultValue={product?.barcode ?? null}
                        label={"Código de barras"}
                      />
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <InputSelect
                        type="text"
                        name="type"
                        label={'Tipo'}
                        options={type}
                        required
                        defaultValue={product?.type ?? 'PRODUCT'}
                      />
                    </div>
                    <div className="col-12 col-md-6 mt-md-0 mt-4">
                      <Input
                        type="text"
                        name="brand"
                        defaultValue={product?.brand ?? null}
                        label={"Marca"}
                      />
                    </div>
                  </div>
                  
                  <div className="row mb-4">
                    <div className="col-12 col-md-6 mt-4">
                      <InputMask
                        type="text"
                        name="costPrice"
                        label={'Preço de custo'}
                        mask={'currency'}
                        defaultValue={product?.costPrice ? currencyFormat(product.costPrice) : null}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-6 mt-4">
                      <InputMask
                        type="text"
                        name="salePrice"
                        label={'Preço de venda'}
                        mask={'currency'}
                        defaultValue={product?.salePrice ? currencyFormat(product.salePrice) : null}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                        }}
                      />
                    </div>
                  </div>
                  
                  <PhotoSection>
                    {(product?.urlPhoto || photo) && (
                      <PhotoPreview
                        onClick={() => {
                          if (product?.urlPhoto) {
                            showImage(`${process.env.REACT_APP_API_ENDPOINT}${product.urlPhoto}`);
                          }
                        }}
                      >
                        <img
                          src={photo ? URL.createObjectURL(photo) : `${process.env.REACT_APP_API_ENDPOINT}${product.urlPhoto}`}
                          alt={"Imagem do produto"}
                        />
                      </PhotoPreview>
                    )}
                    <PhotoInfo>
                      <span className="photo-label">Imagem do produto</span>
                      <CustomButton
                        component="label"
                        role={undefined}
                        variant="outlined"
                        tabIndex={-1}
                        startIcon={<MdInsertPhoto />}
                        style={{
                          background: 'rgba(255, 255, 255, 0.05)',
                          border: '2px solid rgba(0, 212, 255, 0.2)',
                          color: '#00d4ff',
                          padding: '12px 24px',
                          borderRadius: '10px',
                          fontWeight: 600,
                          textTransform: 'none',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = 'rgba(0, 212, 255, 0.1)';
                          e.currentTarget.style.borderColor = 'rgba(0, 212, 255, 0.4)';
                          e.currentTarget.style.transform = 'translateY(-2px)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                          e.currentTarget.style.borderColor = 'rgba(0, 212, 255, 0.2)';
                          e.currentTarget.style.transform = 'translateY(0)';
                        }}
                      >
                        {(product?.urlPhoto || photo) ? 'Alterar imagem do produto' : 'Selecionar imagem do produto'}
                        <VisuallyHiddenInput
                          type="file"
                          accept="image/*"
                          onChange={async (event) => {
                            const file = await compressedImage(event);
                            if (file) {
                              setPhoto(file);
                            }
                          }}
                        />
                      </CustomButton>
                      {photo && (
                        <div className="photo-selected">
                          Imagem selecionada: <strong>{photo.name}</strong>
                        </div>
                      )}
                    </PhotoInfo>
                  </PhotoSection>
                  
                  <ButtonContainer>
                    <Link to="/product" style={{ textDecoration: 'none' }}>
                      <CustomButton
                        variant="outlined"
                        className="btn btn-secondary font-weight-bold text-capitalize mobile-button"
                        startIcon={<BiArrowBack/>}
                        style={{
                          background: 'rgba(255, 255, 255, 0.05)',
                          border: '2px solid rgba(255, 255, 255, 0.2)',
                          color: '#e0e0e0',
                          padding: '14px 28px',
                          borderRadius: '10px',
                          fontWeight: 600,
                          transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                          e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                          e.currentTarget.style.transform = 'translateY(-2px)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                          e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                          e.currentTarget.style.transform = 'translateY(0)';
                        }}
                      >
                        Voltar
                      </CustomButton>
                    </Link>
                    <CustomButton
                      className="btn btn-primary font-weight-bold text-capitalize mobile-button"
                      loading={loading}
                      type="submit"
                      startIcon={<IoMdCheckmark/>}
                      style={{
                        background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
                        border: 'none',
                        color: '#ffffff',
                        padding: '14px 32px',
                        borderRadius: '10px',
                        fontWeight: 600,
                        boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        if (!loading) {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                      }}
                    >
                      Salvar
                    </CustomButton>
                  </ButtonContainer>
                </Form>
              </StyledFormWrapper>
            </ProductCard>
          </>
        )}
      </ContentArea>
    </ProductNewWrapper>
  );
}